/* Step 1 of the feed import flow: shows export instructions for the selected app.
   Works for both podcast and RSS reader apps. */

import { Button } from "@/components/ui/button";
import {
  FEED_APP_INSTRUCTIONS,
  type Step,
} from "@/lib/podcastAppInstructions";

interface PodcastImportInstructionsProps {
  app: string;
  onContinue: () => void;
}

export function PodcastImportInstructions({
  app,
  onContinue,
}: PodcastImportInstructionsProps) {
  const instructions = FEED_APP_INSTRUCTIONS[app];
  if (!instructions) return null;

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-medium mb-3">
          Export from {instructions.label}
        </h3>
        <ol className="space-y-2">
          {instructions.steps.map((step, i) => (
            <li key={i} className="flex items-start gap-2.5 text-sm">
              <span className="flex items-center justify-center size-5 rounded-full bg-muted text-muted-foreground text-xs font-medium shrink-0 mt-0.5">
                {i + 1}
              </span>
              <span className="text-muted-foreground">
                <StepContent segments={step} />
              </span>
            </li>
          ))}
        </ol>
      </div>

      <Button onClick={onContinue} className="w-full">
        I have my OPML file
      </Button>
    </div>
  );
}

function StepContent({ segments }: { segments: Step }) {
  return (
    <>
      {segments.map((seg, i) =>
        seg.url ? (
          <a
            key={i}
            href={seg.url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 text-foreground hover:text-primary transition-colors"
          >
            {seg.text}
          </a>
        ) : (
          <span key={i}>{seg.text}</span>
        ),
      )}
    </>
  );
}
